// Stripe stores amounts in minor units (cents). A change row is one
// subscription item; the amount shown is unit amount × quantity.
function periodAmount(unitAmount, quantity) {
  if (unitAmount == null || !Number.isFinite(Number(unitAmount))) return null;
  const qty = quantity == null ? 1 : Number(quantity);
  return (Number(unitAmount) * qty) / 100;
}

export function formatChangeMoney(value, currency, locale) {
  if (value == null || !Number.isFinite(Number(value))) return "—";
  return Number(value).toLocaleString(locale, {
    style: "currency",
    currency: String(currency || "aud").toUpperCase(),
  });
}

export function formatSignedChangeMoney(value, currency, locale) {
  if (value == null || !Number.isFinite(Number(value))) return "—";
  const formatted = formatChangeMoney(Math.abs(value), currency, locale);
  if (value > 0) return `+${formatted}`;
  if (value < 0) return `−${formatted}`;
  return formatted;
}

export function formatChangePercent(value) {
  if (value == null || !Number.isFinite(Number(value))) return "—";
  const rounded = Math.round(value * 10) / 10;
  if (rounded > 0) return `+${rounded.toFixed(1)}%`;
  if (rounded < 0) return `−${Math.abs(rounded).toFixed(1)}%`;
  return "0.0%";
}

export function formatChangeDate(value, locale) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleDateString(locale, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

export function summarizePriceChange(change, locale) {
  const currency = change.newCurrency || change.oldCurrency || "aud";
  const oldAmount = periodAmount(change.oldUnitAmount, change.oldQuantity);
  const newAmount = periodAmount(change.newUnitAmount, change.newQuantity);
  const difference = oldAmount != null && newAmount != null ? newAmount - oldAmount : null;
  const percent = difference != null && oldAmount ? (difference / oldAmount) * 100 : null;
  return {
    key: `${change.eventId || change._id}-${change.subscriptionItemId || ""}`,
    date: formatChangeDate(change.changedAt, locale),
    oldAmount: formatChangeMoney(oldAmount, change.oldCurrency || currency, locale),
    newAmount: formatChangeMoney(newAmount, currency, locale),
    difference: formatSignedChangeMoney(difference, currency, locale),
    percent: formatChangePercent(percent),
    interval: change.newInterval || change.oldInterval || null,
    automatic: change.source === "automatic",
  };
}

export function priceChangesFor(priceChanges, subId) {
  if (!priceChanges || !subId) return [];
  const list = priceChanges[String(subId)];
  return Array.isArray(list) ? list : [];
}
